import type { Strings } from '../index.ts';

/**
 * Die Videos aus den anderen Visious-Tabs in diesen verschieben: der Knopf in der Kopfzeile, die
 * Rückfrage, die er öffnet, und was ein Tab sagt, wenn der Browser ihn nicht schließen ließ.
 *
 * Nichts hier verspricht, dass ein Tab sich schließt. Das entscheidet der Browser, deshalb sagt die
 * Rückfrage nur, dass die Tabs nach Möglichkeit geschlossen werden, und der eine Satz danach gehört
 * den Tabs, die offen geblieben sind.
 */
export const tabs: Strings['tabs'] = {
  open: 'Videos aus den Warteschlangen anderer Tabs hierher verschieben',

  empty: 'Es gibt keine anderen Tabs mit Videos.',

  ask: {
    title: 'Videos aus anderen Tabs verschieben',
    detail:
      'Die Videos aus deinen anderen Visious-Tabs werden in die Warteschlange dieses Tabs verschoben, und diese Tabs werden nach Möglichkeit geschlossen.',
    linked:
      'Die Warteschlange dieses Tabs folgt einer Playlist. Wenn du sie vorher löst, bleiben die Videos dieser Playlist in der Warteschlange.',
    confirm: 'Verschieben',
    unlink: 'Lösen und verschieben',
    cancel: 'Abbrechen',
    working: 'Deine anderen Tabs werden gefragt.',
    close: 'Schließen',
  },

  stayed: 'Einige Tabs konnten nicht geschlossen werden und müssen von Hand geschlossen werden.',

  handedOver: {
    title: 'Die Videos sind jetzt in einem anderen Tab',
    detail: 'Dein Browser hat das Schließen dieses Tabs nicht erlaubt. Bitte schließe ihn selbst.',
  },
};
